import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { useDispatch, useSelector } from 'react-redux'
import { reduxBatch } from '@manaflair/redux-batch'
import {
  getFormValid,
  hangerActions,
  jobSettingsActions,
  settingsActions,
} from '../../../store/slices'

import { connectionOptions } from '../../../common/json/common.json'
import { ANSI_TPI, CONNECTION_TYPE } from '../../../common/constants'
import { COUNTRY } from '../../../../../utils/constants'
import { useModal } from '../../../../../utils/hooks'

import { Accordion, ButtonGroup, Modal } from '../../../../../components'

const ConnectionSelection = ({ country, connectionType }) => {
  const dispatch = useDispatch()
  const [show, toggle] = useModal()

  const isValid = useSelector(getFormValid)

  const handleSelectConnection = (name, value) => {
    if (isValid) {
      reduxBatch([
        dispatch(hangerActions.resetHangerState()),
        dispatch(
          jobSettingsActions.updateCalculation({
            upliftLoadDurationType: country === COUNTRY.USA ? 160 : 115,
            downloadDurationType:
              country === COUNTRY.USA ? (value === CONNECTION_TYPE.JOIST ? 100 : 125) : 100,
            ansitpi: ANSI_TPI[country],
          }),
        ),
        dispatch(settingsActions.modifyCalculation({ name, value })),
      ])
    } else toggle()
  }
  return (
    <Accordion title="Connection Type">
      <ButtonGroup
        className="row"
        name="connectionType"
        colClassName="col-12 col-sm-4  col-md-4 col-lg-4 col-xl-4 col-xxl-4"
        value={connectionType}
        options={connectionOptions}
        onChange={handleSelectConnection}
        containerProps={{ 'data-testid': 'connectionType' }}
      />
      <Modal
        header={
          <Modal.Header closeButton>
            <h3>Validation error</h3>
          </Modal.Header>
        }
        show={show}
        onHide={toggle}
      >
        Before switching between Connection Types, you must clear out any errors in the input fields
        below.
      </Modal>
    </Accordion>
  )
}

ConnectionSelection.propTypes = {
  country: PropTypes.string.isRequired,
  connectionType: PropTypes.string.isRequired,
}

export default memo(ConnectionSelection)
